import React from 'react';
import TargetUniqueAttributeTable from './TargetUniqueAttributeTable';
import NoDataComponent from 'Components/Common/NoDataComponent';
type TargetUniqueAttributesProps = {
  payload: TRecategorizePayload;
  recategorizationResponse: RecategorizationResponse | undefined;
}
const TargetUniqueAttributes = ({ payload, recategorizationResponse }: TargetUniqueAttributesProps) => {

  if (recategorizationResponse?.unique_attr_target_list?.length === 0) {
    return <NoDataComponent />;
  }

  return (
    <TargetUniqueAttributeTable payload={payload} recategorizationResponse={recategorizationResponse}/>
  );
}

export default TargetUniqueAttributes;